// @ts-strict-ignore
import * as React from 'react';
import Form, { Rule } from 'antd/lib/form';
import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import Input from 'antd/lib/input';
import Text, { TextProps } from 'antd/lib/typography/Text';
import FormItem from 'antd/lib/form/FormItem';
import useForm from 'antd/lib/form/hooks/useForm';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { RunwayUserAction } from '../helpers/aclHelpers';
import PermissionedActionButton from './HOCs/PermissionedActionButton';
import { antGrey } from './styles/globalStyles';

interface AppSettingsActionsComponentProps {
    recordId: number | string;
    isEditing: boolean;
    saveIsLoading: boolean;
    saveDisabled: boolean;
    deleteConfirmationText: string;
    saveButtonOnClick: (id: number | string) => void;
    editCancelButtonClicked: (id: number | string) => void;
    editStartButtonClicked: (id: number | string) => void;
    deleteConfirm: (id: number | string) => void;
    editPermissionedActionType?: RunwayUserAction;
    deletePermissionsedActionType?: RunwayUserAction;
    disabled?: boolean;
    hideEdit?: boolean;
}

export const AppSettingsActionsComponent = (props: AppSettingsActionsComponentProps) => {
    let editButton = null;
    let deleteButton = null;

    const editIcon = <EditOutlined style={{ color: antGrey.grey7 }} />;

    if (props.hideEdit) {
        editButton = null;
    } else if (!props.isEditing && props.editPermissionedActionType) {
        editButton = (
            <PermissionedActionButton
                actionType={props.editPermissionedActionType}
                type="text"
                icon={editIcon}
                title="Edit"
                disabled={props.disabled}
                onClick={() => {
                    props.editStartButtonClicked(props.recordId);
                }}
            />
        );
    } else if (!props.isEditing) {
        editButton = (
            <Button
                type="text"
                icon={editIcon}
                title="Edit"
                disabled={props.disabled}
                onClick={() => {
                    props.editStartButtonClicked(props.recordId);
                }}
            />
        );
    }

    const deleteIconButton =
        props.deletePermissionsedActionType ?
            <PermissionedActionButton
                actionType={props.deletePermissionsedActionType}
                type="text"
                danger
                icon={<DeleteOutlined />}
                title="Delete"
                disabled={props.disabled}
            />
        :   <Button
                style={{ marginLeft: 6 }}
                type="text"
                danger
                icon={<DeleteOutlined />}
                title="Delete"
                disabled={props.disabled}
            />;

    deleteButton = (
        <Popconfirm
            placement="topRight"
            title={props.deleteConfirmationText}
            disabled={props.disabled}
            onConfirm={() => props.deleteConfirm(props.recordId)}
        >
            {deleteIconButton}
        </Popconfirm>
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {props.isEditing && (
                <div>
                    <Button
                        type="primary"
                        onClick={() => props.saveButtonOnClick(props.recordId)}
                        loading={props.saveIsLoading}
                        disabled={props.saveDisabled}
                    >
                        Save
                    </Button>
                    <Button
                        style={{ marginLeft: 6 }}
                        onClick={() => {
                            props.editCancelButtonClicked(props.recordId);
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            )}
            {editButton}
            {deleteButton}
        </div>
    );
};

interface AppSettingsEditableInputComponentProps {
    id: number | string;
    isEditing: boolean;
    defaultValue: string;
    textProps?: TextProps;
    rules?: Rule[];
    onValueChanged: (id: number | string, value: string, isValid: boolean) => void;
}

export const AppSettingsEditableInputComponent = (props: AppSettingsEditableInputComponentProps) => {
    const [form] = useForm();

    const onFieldsChange = () => {
        const errors = form.getFieldError('mainInput');
        const value = form.getFieldValue('mainInput');

        props.onValueChanged(props.id, value, errors.length === 0);
    };

    React.useEffect(() => {
        if (!props.isEditing) {
            form.setFieldsValue({ mainInput: props.defaultValue });
        }
    }, [props.isEditing]);

    return (
        <div>
            {props.isEditing && (
                <Form form={form} initialValues={{ mainInput: props.defaultValue }} onFieldsChange={onFieldsChange}>
                    <FormItem name="mainInput" rules={props.rules}>
                        <Input autoComplete="off" />
                    </FormItem>
                </Form>
            )}
            {!props.isEditing && <Text {...props.textProps}>{props.defaultValue}</Text>}
        </div>
    );
};
